$(function () {
    // pour des alerts
    $('.bootbox-alert').on('click', function (e) {
        const $this = $(this)
        const message = $this.data('message')
        const title = $this.data('title')
        formElementAlert = $this.data('form')
        bootbox.alert({
            title: title,
            message: message,
            callback: function () {
                if (formElementAlert) {
                    $(formElementAlert).submit();
                }
            }
        })
        e.preventDefault();
    })
    // pour confirm
    $('.bootbox-confirm-delete').on('click', function (e) {
        const $this = $(this)
        const message = $this.data('message')
        const title = $this.data('title')
        formElement = $this.data('form')
        bootbox.confirm({
            message: message,
            title: title,
            buttons: {
                confirm: {
                    label: 'Oui',
                    className: 'btn btn-secondary'
                },
                cancel: {
                    label: 'Annuler',
                    className: 'btn'
                }
            },
            callback: function (result) {
                if (result && formElement) {
                    $(formElement).submit();
                }
            }
        })

        e.preventDefault();
    })
})


// WEBPACK FOOTER //
// ./resources/assets/js/components/bootbox.js